import React from 'react';
import { ButtonProps, Button as AntdButton } from 'antd';
import styles from './Button.module.less';
import classnames from 'classnames';

export const Button = ({ children, className, ...props }: ButtonProps) => {
  return (
    <AntdButton className={classnames([styles.button, className])} {...props}>
      {children}
    </AntdButton>
  );
};

export default Button;
